import { useState, useEffect } from "react";
import Common from "../common/Common";
import { useNavigate } from "react-router-dom";

const DisplayPlan = ({ isOpen, tasks, goal,startdate,enddate }) => {
  const navigate = useNavigate();

  const getRandomColor = () => {
    const colors = [
      "bg-red-100",
      "bg-orange-100",
      "bg-yellow-100",
      "bg-green-100",
      "bg-blue-100",
      "bg-indigo-100",
      "bg-purple-100",
      "bg-pink-100",
      "bg-teal-100",
      "bg-cyan-100",
    ];
    const randomIndex = Math.floor(Math.random() * colors.length);
    return colors[randomIndex];
  };

  const savePlanTasks = async () => {
    try {
      let response2 = await fetch(`${process.env.REACT_APP_NODEURL}/savePlan`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          plan: goal,
          description: goal,
          start: new Date(startdate),
          end: new Date(enddate),
        }),
      });
      let ans2 = await response2.json();
      if (ans2.msg == "success") {
        let planid = ans2.res._id
        tasks.map((item) => {
          item.type = "Plan";
          item.goal = goal;
          item.planid  = planid
        });
        let res = await fetch(`${process.env.REACT_APP_NODEURL}/bulkInsert`, {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ tasks: tasks }),
        });

        let ans = await res.json();
        if (ans) {
          navigate("/dashboard");
        }
      }
    } catch (e) {}
  };
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center text-gray-900 bg-black bg-opacity-50 z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg w-100 max-h-[80vh] overflow-hidden flex flex-col">
        <h2 className="text-lg font-bold text-center">
          Your Plan Is Ready. Click confirm to create
        </h2>

        {/* Scrollable Content Area */}
        <div className="overflow-y-auto flex-1 mt-3">
          <table className="table-auto w-full">
            <thead>
              <tr>
                <th className="border px-4 py-2">Tasks</th>
                <th className="border px-4 py-2">Start Time</th>
                <th className="border px-4 py-2">End Time</th>
              </tr>
            </thead>
            <tbody>
              {tasks.map((item, index) => (
                <tr key={index} className={`${getRandomColor()}`}>
                  <td className="border px-4 py-2" contentEditable>
                    {item.tasks}
                  </td>
                  <td className="border px-4 py-2" contentEditable>
                    {item.startTime}
                  </td>
                  <td className="border px-4 py-2" contentEditable>
                    {item.endTime}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Buttons */}
        <div className="flex items-center justify-center mt-3 space-x-4 ">
          <button
            className="px-4 py-2 bg-green-500 text-white rounded confirmBatch"
            onClick={savePlanTasks}
          >
            Confirm
          </button>
          <button className="px-4 py-2 bg-red-500 text-white rounded">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default DisplayPlan;
